export const getIsSyllabusPageEducatorSpecific = (educatorUID, author) =>
  !!educatorUID && author && !!author.firstName;

export const getIsChapterMissing = (chapters) =>
  chapters.some((chapter) => !chapter.educatorCoveredConcept);
